import React from "react";
import wallet from "../../images/blockchain/empty-wallet-add.svg";
import users from "../../images/blockchain/ai-users.svg";
import network from "../../images/blockchain/status-up.svg";
import sheild from "../../images/blockchain/strongbox-2.svg";
const WalletSection = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-8">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className=" text-white text-center opacity-75">
                {/*   How to Understand the Value of Your TopCoin Rewards */}
                      How to Understand Your TopCoin  Rewards
                </h1>
                <p className="text-white text-center opacity-50">
          
                  TopCoin UK operates a customer loyalty and advertising rewards programme.
                </p>
                <p className="text-white text-center opacity-50">
        
                  When you shop with participating businesses, you may receive TopCoin units as 
                  free promotional rewards issued by those businesses as part of their marketing 
                  activity. Collecting 
                </p>
                <p className="text-white text-center opacity-50">
                  more TopCoins may unlock additional promotional benefits,
                   based on predefined programme milestones.
                </p>


               {/*  next section */}
               <div className="card bg-white border border-opacity-75 shadow-sm mt-3 mb-2">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                     TopCoin rewards:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                       Are not an investment
                      </li>
                      <li>
                        Do not earn interest
                      </li>
                      <li>
                       Do not increase in value over time
                      </li>
                      <li>
                        Are not linked to speculation, trading, or financial growth
                      </li>
                      <li>
                        Are funded by participating businesses as part of their 
                        advertising and customer engagement programmes
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="text-white text-center opacity-50">
                      TopCoin UK does not sell, issue, or promote financial products.
                </p>


              <div>
                  <div className="text-center py-3">           
                    <h4>How Promotional Values Are Displayed</h4>
                  </div>
                  <p className="text-white text-center opacity-50">
                    Any values shown within the platform are presented solely to 
                    illustrate how merchant-funded promotional rewards are allocated 
                    and tracked within the loyalty programme.
                  </p>
              </div>


               <div className="card bg-white border border-opacity-75 shadow-sm mt-3 mb-2">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                     These displays:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                      Do not represent savings, income, or returns
                      </li>
                      <li>
                        Do not guarantee availability or payout
                      </li>
                      <li>
                       Are illustrative only and subject to programme rules and merchant participation
                      </li>
                    </ul>
                  </div>
                </div>


                <div>
                  <div className="text-center py-3">           
                    <h4>1. Promotional Reward Allocation</h4>
                  </div>
                  <p className="text-white text-center opacity-50">
                   Participating businesses may allocate promotional 
                   discounts into the programme as part of their advertising spend..
                  </p>
                </div>


                <div>
                  <div className="text-center py-2">           
                    <h4>2. Proportional Display</h4>
                  </div>
                  <p className="text-white text-center opacity-50">
                   Where applicable, promotional discount allocations may 
                   be displayed proportionally based on customer engagement 
                   and TopCoin collection levels.
                  </p>
                </div>





                <div className="text-center">   
                   {" "}        
                    <h4> Availability</h4>
                </div>
               <div className="card bg-white border border-opacity-75 shadow-sm mt-3 mb-2">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                    Any promotional reward shown as available is subject to:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                      Programme terms
                      </li>
                      <li>
                        Verification requirements
                      </li>
                      <li>
                      Merchant funding and conditions
                      </li>
                    </ul>
                  </div>
                </div>



                <div className="text-center py-3"> 
                   {" "}          
                    <h4>Important Regulatory Notice</h4>
                </div>
               <div className="card bg-white border border-opacity-75 shadow-sm mt-3 mb-2">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                     TopCoin UK:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                      Is not a bank
                      </li>
                      <li>
                        Is not an investment platform
                      </li>
                      <li>
                      Does not provide financial advice
                      </li>
                      <li>
                        Does not accept customer deposits
                      </li>
                      <li>
                        Does not offer savings, payment, or investment services
                      </li>
                    </ul>
                  </div>
                </div>


                <p className="text-white text-center opacity-50">
                   TopCoin UK is not regulated by the Financial Conduct Authority (FCA), 
                   as it does not operate within regulated financial activities..
                </p>


                <p className="text-white text-center opacity-50">
                    All rewards shown are loyalty-based promotional benefits, not financial
                    assets or guaranteed cash entitlements.
                </p>

                 



               {/* end */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="text-center py-3">
            {" "}
            <h4>{/* Step-by-Step Calculation */}
              Step-by-Step Illustration (Promotional Rewards Only)
            </h4>
             <p className="text-white text-center opacity-50">
                  This page explains how promotional reward values 
                  are displayed within the TopCoin UK loyalty programme.
              </p>
              <p className="text-white text-center opacity-50">
                  All examples shown are illustrative only and are not financial returns.
              </p>
              
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  {/* 1. Reward Value Allocation */}
                  1. Promotional Value Allocation
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {/* Each TopCoin Cash reward Wallet contains a pre-funded
                    promotional reward amount */}
                    Each TopCoin Reward Cash Wallet may contain merchant-funded promotional value provided as 
                    part of participating businesses’ advertising activity.
                  </li>
                  <li>
                    {/* The value allocated to each TopCoin is determined by
                    dividing the wallet amount by the total number of TopCoin */}
                    Any displayed value is calculated by dividing the total promotional amount 
                    in that wallet by the total number of TopCoins recognised at that wallet level.
                  </li>
                  <li>
                    {/* This is strictly a reward allocation, not an investment
                    return. */}
                    This process is used only to illustrate how promotional discounts 
                    are proportionally allocated.
                  </li>
                  <li>
                    This is not an investment, yield, interest, or profit distribution
                  </li>
                </ul>
              </div>
            </div>
            <div className="card bg-white">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  {/* 2. Calculate Your Total Rewards */}
                  2. Viewing Your Promotional Allocation
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {" "}
                   {/*  Once you know the TopCoin reward value, multiply it by the
                    number of TopCoin you have. */}
                    Once a wallet milestone is reached, the platform may display an indicative 
                    promotional allocation linked to your TopCoin balance
                  </li>
                  <li>
                    {/* Repeat this for each reward wallet that you have unlocked. */}
                    The displayed amount reflects participation in the loyalty programme, 
                    not ownership of funds.
                  </li>
                  <li>
                  {/*   Add the values from all unlocked wallets to understand your
                    total TopCoin promotional rewards. */}
                    Promotional values may vary depending on
                  </li>
                  <li>
                    {" "}
                    {/* The reward value is calculated by dividing the promotional
                    wallet amount by the total number of TopCoin in the system. */}
                    Merchant participation
                  </li>
                  <li>
                    Programme rules
                  </li>
                  <li>
                    Wallet status (locked / available)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  Example Calculation (Illustration Only)
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>Example scenario (not guaranteed or representative):
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        Promotional wallet value: £1,000
                      </li>
                      <li>
                        Total TopCoins recognised at that level: 5,000
                      </li>
                      <li>
                        Illustrative promotional value per TopCoin: £0.20
                      </li>
                    </ul>
                  </li>
                  <li>
                    If a customer holds 300 TopCoins, the platform may display:
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        300 × £0.20 = £60 (illustrative promotional value)
                      </li>

                    </ul>
                  </li>
                  <li>
                    This example is shown for explanation purposes only.
                  </li>
                </ul>



                {/* <ul className="mb-0 text-dark-emphasis">
                  <li>Promotional Wallet Value: £1,000</li>
                  <li>Total TopCoin 5,000</li>
                  <li>Reward Value per topcoin</li>
                  <li>£1,000 ÷ 5,000 = £0.20 (20p per TopCoin)</li>
                </ul> */}
              </div>
            </div>
            <div className="card bg-white">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  Important Clarification
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {" "}
                    {/* If you have 300 TopCoin and the promotional value per
                    topcoin is £0.20, then your reward from this wallet would
                    be: 300 × £0.20 = £60 promotional value */}
                    TopCoin UK is a loyalty and advertising platform, not a financial service.
                  </li>
                  <li>
                    {/* Repeat this for each unlocked wallet, then add the totals to
                    see your overall reward value. */}
                    TopCoins are not money, not investments, and do not increase in value.
                  </li>

                  <li>
                    Displayed promotional values:
                  </li>
                  <li>
                    Are not guaranteed
                  </li>
                  <li>
                    Are not savings or income
                  </li>
                  <li>
                    Do not represent ownership, equity, or profit rights
                  </li>
                  <li>
                    TopCoin UK does not hold customer deposits and does not provide payment or investment services.
                  </li>
                {/*   <li>
                    Important Note:
                    <ul>
                      <li>
                        {" "}
                        TopCoin is a loyalty and promotional rewards programme,
                        not an investment.
                      </li>
                      <li>
                        Reward values relate to promotional wallet balances and
                        programme structure.
                      </li>
                    </ul>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>


        {/* new section */}
        <div className="text-center py-3">
            {" "}
            <h4>{/* Step-by-Step Calculation */}
              Regulatory Notice
            </h4>
             <p className="text-white text-center opacity-50">
                  TopCoin UK is not regulated by the Financial Conduct 
                  Authority (FCA), as it does not carry out regulated 
                  financial activities.
              </p>
              <p className="text-white text-center opacity-50">
                  All rewards shown are merchant-funded 
                  promotional benefits issued through a 
                  loyalty programme.
              </p>
              
          </div>

        {/* end new section */}
        <div class="row justify-content-center mt-3">
          <div className="col-lg-8">
            <h4>{/* Role of TopCoin UK */}
              Role of TopCoin UK (Loyalty Programme Only)
               </h4>
            <p >           
              TopCoin UK operates a customer loyalty and promotional rewards programme.
            </p>
            <p>           
              As customers interact with participating businesses, they may unlock 
              reward levels based on predefined programme milestones.
            </p>
            <p>
             If a customer chooses to access available rewards before reaching the next 
             milestone, any displayed reward is based only on milestones already unlocked and 
             the current promotional structure of the programme.
            </p>
            <p>
              There is no investment activity, financial return, interest, or yield involved at any stage.
            </p>
            <p>
              All rewards are promotional in nature and funded through participating businesses’ advertising activity.
            </p>
          </div>
        </div>

        {/* heading */}
                 <div className="text-center py-3"> 
                   {" "}          
                    <h4>How the System Works</h4>
                </div>


        <div className="container">
          <div className="row">           
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body  p-4">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="icon-img">
                      <img src={wallet} width={24} alt="" />
                    </div>
                    <div className="text-dark opacity-75">
                      <h5 className="text-dark-emphasis">
                        Promotional Reward Wallets
                      </h5>
                      
                      Each TopCoin UK reward wallet may contain merchant-funded promotional value allocated as 
                      part of a loyalty promotion. These values are not savings, deposits, or financial instruments.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body p-4">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="icon-img">
                      <img src={users} width={24} alt="" />
                    </div>
                    <div className="text-dark opacity-75">
                     <h5 className="text-dark-emphasis">
                        Secure Recording
                      </h5>
                      TopCoin units are securely recorded within the TopCoin UK system for tracking loyalty 
                      participation only. They do not represent money, assets, or ownership rights.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body p-4">
                  <div className="d-flex gap-3 justify-content-center align-items-center">
                    <div className="icon-img">
                      <img src={sheild} width={24} alt="" />
                    </div>                   
                    <div className="text-dark opacity-75"> 
                       <h5 className="text-dark-emphasis">
                        Milestone Structure
                      </h5>                    
                      Unlocked rewards follow a structured milestone system. Progression is sequential and based solely on participation
                       within the programme
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body p-4">
                  <div className="d-flex gap-3 align-items-center">                   
                    <div className="icon-img">
                      <img src={network} width={24} alt="" />
                    </div>                  
                    <div className="text-dark opacity-75">
                       <h5 className="text-dark-emphasis">
                        Independent Business Participation
                    </h5>                
                      Each participating business operates within its own promotional rewards structure under the TopCoin
                       UK network. TopCoin UK does not operate as a bank, payment provider, or investment platform
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
                   <div className="text-center py-3"> 
                   {" "}          
                    <h4>Important Notice</h4>
                    <p className="text-white text-center opacity-50">
                      TopCoin UK is a loyalty and promotional rewards programme.
                    </p>
                </div>
               <div className="card bg-white border border-opacity-75 shadow-sm mt-3 mb-2">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                     It is not cryptocurrency, not an investment, and not a financial services product.
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                      No interest is paid
                      </li>
                      <li>
                       No profits or speculative returns are offered
                      </li>
                      <li>
                      No ownership, equity, or income rights are created
                      </li>
                    </ul>
                  </div>
                </div>
        <p className="text-center">
         {/*  TopCoin UK is a loyalty and promotional rewards 
          programme. It is not cryptocurrency, not an investment, 
          and not a financial services product. No interest, profit, 
          or speculative returns are provided. */}
          TopCoin UK does not hold customer deposits and does not provide 
          regulated financial services.
        </p>
        <p className="text-center">
          TopCoin UK is not regulated by the Financial Conduct Authority (FCA) 
          because it does not provide financial services, investments, payment 
          products, or savings accounts.
        </p>
        <p className="text-center">
          All values shown are promotional illustrations 
          only and subject to programme terms.
        </p>
      </div>
    </section>
  );
};

export default WalletSection;
